export type DeviceTier = 'audio_only' | 'smart_display' | 'legacy' | 'mid' | 'modern' | 'unknown';

interface CastDeviceCapabilities {
  IS_VIDEO_SUPPORTED?: boolean;
  IS_AUDIO_SUPPORTED?: boolean;
  IS_TOUCH_SUPPORTED?: boolean;
}

export function getDeviceTier(): DeviceTier {
  const context = (window as any).cast?.framework?.CastReceiverContext?.getInstance?.();
  const caps: CastDeviceCapabilities = context?.getDeviceCapabilities?.() ?? {};

  const ua = navigator.userAgent ?? '';

  const isAndroidTV = ua.includes('DeviceType/AndroidTV');
  const isChromecastDongle = ua.includes('DeviceType/Chromecast');
  const isChromecast = ua.includes('CrKey') || ua.includes('Chromecast');
  const isFuchsia = ua.includes('Fuchsia');
  const isGoogleTV = ua.includes('Google TV');

  if (caps.IS_VIDEO_SUPPORTED === false) {
    return 'audio_only';
  }

  if (caps.IS_TOUCH_SUPPORTED || isFuchsia) {
    return 'smart_display';
  }

  if (isAndroidTV || isGoogleTV) {
    return 'modern';
  }

  if (isChromecastDongle) {
    return 'mid';
  }

  if (isChromecast) {
    return 'legacy';
  }

  return 'unknown';
}

export function getDeviceCapabilities(): string[] {
  const context = (window as any).cast?.framework?.CastReceiverContext?.getInstance?.();
  const caps: CastDeviceCapabilities = context?.getDeviceCapabilities?.() ?? {};

  return (Object.keys(caps) as (keyof CastDeviceCapabilities)[]).filter((key) => caps[key] === true);
}
